export default __webpack_public_path__ + "static/media/70.7c0838b9.jpg";